'use client';
import React from 'react';
import { isCustomExpand } from './common';

function CustomExpandContent({ row, expandable }) {
  const ref = React.useRef(null);

  React.useEffect(() => {
    if (isCustomExpand(expandable)) {
      if (ref.current) {
        row.getIsExpanded() ? (ref.current.style.display = 'block') : (ref.current.style.display = 'none');
      }
    }
  }, [row.getIsExpanded()]);

  return (
    <>
      {isCustomExpand(expandable) && row.getCanExpand() ? (
        <tr>
          <td colSpan={row.getVisibleCells().length} className="custom_expand_td">
            <div style={{ backgroundColor: 'white' }} ref={ref}>
              {expandable?.expandedRowRender(row.original, row.getIsExpanded())}
            </div>
          </td>
        </tr>
      ) : null}
    </>
  );
}

function ExpandIcon({ row }) {
  const clickExpand = () => {
    row.getToggleExpandedHandler()();
  };
  return (
    <>
      {row.getCanExpand() && (
        <div onClick={clickExpand} className="expand_icon_parent" style={{ color: '#0071D0' }}>
          {row.getIsExpanded() ? <div className="icon-24-minus-mono " /> : <div className="icon-24-plus-mono " />}
        </div>
      )}
    </>
  );
}

export { CustomExpandContent, ExpandIcon };
